

import { FC, useState, createContext, useContext } from 'react'
import { UpdateTranslationeDto } from './_models'

const ListViewContext = createContext<{itemIdForUpdate?:UpdateTranslationeDto, setItemIdForUpdate?: any}>({})

const ListViewProvider: FC = ({children}) => {
  const [itemIdForUpdate, setItemIdForUpdate] = useState<UpdateTranslationeDto>()

  return (
    <ListViewContext.Provider
      value={{
        itemIdForUpdate,
        setItemIdForUpdate,
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

const useListView = () => useContext(ListViewContext)

export {ListViewProvider, useListView}
